export function latest(dates: Date[]): Date {
  return new Date(Math.max(...dates.map((d) => d.getTime())));
}

export function earliest(dates: Date[]): Date {
  return new Date(Math.min(...dates.map((d) => d.getTime())));
}
